<template>
   <billing-Layout>
  <slot>
        <div class="page-breadcrumb">
            <div class="row">
                <div class="col-5 align-self-center">
                    <h4 class="page-title">Setting Tax</h4>
                </div>
                <div class="col-7 align-self-center">
                    <div class="d-flex align-items-right justify-content-end">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link :to="'/setting'" class="btn btn-info btn-sm mr-2"><i class="fas fa-arrow-left"></i> Back</router-link>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
      
        <div class="container-fluid">
            <div class="row">
            <div class="col-12">

        <div class="card card-body">
            <div class="table-responsive">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th scope="col">STATE</th>
                        <th scope="col">TAX</th>
                        <th scope="col"><button class="btn btn-success btn-sm mr-2 float-right" @click="MetAddNewTaxBtn"><i class="fas fa-plus"></i> New Tax</button></th>
                    </tr>
                </thead>
                <draggable 
              v-model="TaxesLists"
              tag="tbody" 
              class="tbody"
              v-bind="dragOptions"
              @change="checkMove"
              @start="isDragging = true"
              @end="isDragging = false"
              handle=".handle"
            >
                    <tr v-for="taxeitem in TaxesLists" :key="taxeitem.id" class="handle">
                        <td scope="row" style="position:relative"><span style="margin-left:15px;">{{taxeitem.statename}}</span><div class="btnmove"><i class="fas fa-ellipsis-v"></i></div></td>
                        <td>{{taxeitem.name}} %</td>
                        <td><button class="btn btn-secondary btn-sm float-right" @click="MetEditStateBtn(taxeitem.id,taxeitem.name,taxeitem.state_id,taxeitem.status)"><i class="fas fa-edit"></i></button><button class="btn btn-danger btn-sm mr-2 float-right" @click="deleteTaxBtn(taxeitem.id)"><i class="fas fa-times"></i></button></td>
                    </tr>
               </draggable>
            </table>
            <Loader v-if="isLoadingStates"></Loader>
            <div v-if="NoRecordTaxe ==true" class="text-center">no record</div>
            </div>
 
                </div>
              </div>
            </div>
        </div>
         <modal name="setting-taxe" height="auto">
         <div class="card-header">TAXES <button @click="closeModal" class="closeIcon"><span></span></button></div>
            <div class="card-body">

            <form @submit.prevent="MetSAddTaxes">
            <div class="form-row">
                <div class="col-5">
                    <small id="emailHelp" class="form-text text-muted"> State:</small>
                <select class="form-control" v-model="FormTax.state_id">
                    <option value="0">--State--</option>
                    <option v-for="state in statesList" :key="state.id" v-bind:value="state.id">{{state.name}}</option>
                    </select>
                    
                    
                </div>
                <div class="col-2">
                    <small id="emailHelp" class="form-text text-muted"> Tax (%)</small>
                <input type="text" class="form-control" placeholder="0.01" v-model="FormTax.nametaxes">
                <input type="hidden" v-model="FormTax.idtax">
                </div>
                <div class="col-3">
                    <small id="emailHelp" class="form-text text-muted"> Status:</small>
                <select class="form-control" v-model="FormTax.status">
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                    </select>
                    
                    
                </div>
                <div class="col-2">
                    <small id="emailHelp" class="form-text text-muted">.</small>
                <button type="submit" class="btn btn-success">{{FormTax.btnNameTax}}</button>
                </div>
            </div>
            </form>
<Loader v-if="isLoadingStates"></Loader>
            </div>
        </modal>
    </slot>
    
   <notifications group="noti" position="top center"></notifications>
   </billing-Layout> 
</template>
<script>
import axios from 'axios'
import draggable from "vuedraggable";
import Loader from '@/components/shared/Loader'
import BillingLayout from '@/Layouts/Billing/BillingLayout'

export default {
  components:{
      BillingLayout,
      Loader,
      draggable
  },
  data() {
    return {
      isLoadingStates : false,
      statesList: [],
      TaxesLists :[],
      FormTax: {
        btnNameTax : 'ADD',
        ActionTaxe : 'AddTaxe',
        idtax : null,
        nametaxes : null,
        state_id : 0,
        status : 1
      },
      
      NoRecordTaxe : false
      
    }
  },
   mounted(){
    this.getStates();
    this.getTaxes();
    },
     methods:{
       
         closeModal(){
        this.$modal.hide('setting-taxe')
        },
        getStates() {
            this.isLoadingStates = true
            window.billing.get('states/' + window.localuserdata)
                .then((response) => {
					 console.log(response.data.resultStates)         
                    this.statesList = response.data.resultStates;
					this.isLoadingStates = false
                }).catch((error) => console.log(error));
        },
        MetSAddTaxes(){
          this.isLoadingStates = true
        if(this.FormTax.ActionTaxe == 'AddTaxe'){
           window.billing.post('taxes/add',{
                user_id : window.localuserdata,
                name: this.FormTax.nametaxes,
                state_id: this.FormTax.state_id,
                status: this.FormTax.status
           }).then((response) => {
                 console.log(response.data);
                 this.isLoadingStates = false
                 this.FormTax.nametaxes= null;
                 this.FormTax.state_id = 0;
                 this.FormTax.status = 1;
                 this.NoRecordTaxe = false
                 this.$modal.hide('setting-taxe')
                 this.getTaxes()
                 this.$notify({
                    group: 'noti',
                    title: 'Add',
                    type: 'success',
                    text: 'Add Taxes Successful'
                  });
                }).catch((error) => console.log(error,this.isLoading = false));
        }
        if(this.FormTax.ActionTaxe == 'UpdateTaxe'){
            this.isLoadingStates = true
           window.billing.put('taxes/edit/' + this.FormTax.idtax ,{
                user_id : window.localuserdata,
                idtax: this.FormTax.idtax,
                name: this.FormTax.nametaxes,
                state_id: this.FormTax.state_id,
                status: this.FormTax.status
           }).then((response) => {
                 console.log(response.data);
                 this.FormTax.nametaxes = null;
                 this.FormTax.state_id = 0;
                 this.FormTax.btnNameTax = 'ADD';
                 this.FormTax.ActionTaxe = 'AddTaxe';
                 this.NoRecordTaxe = null
                 this.isLoadingStates = false
                 this.$modal.hide('setting-taxe')
                 this.getTaxes()
                  this.$notify({
                    group: 'noti',
                    title: 'Updated',
                    type: 'success',
                    text: 'Updated Taxes Successful'
                  });
                }).catch((error) => console.log(error,this.isLoading = false));
        }
        },
        getTaxes() {
            window.billing.get('taxes/' + window.localuserdata)
                .then((response) => {
					 console.log(response.data)
                    this.TaxesLists = response.data;
                    if(this.TaxesLists.length ==0){
                      this.NoRecordTaxe = true
                    }
				this.isLoadingStates = false
                }).catch((error) => console.log(error));
        },
        MetEditStateBtn(idtax,name,idstate,status){
            this.$modal.show('setting-taxe');
          this.FormTax = {
            btnNameTax : 'UPDATE',
            ActionTaxe : 'UpdateTaxe',
            nametaxes : name,
            state_id : idstate,
            idtax : idtax,
            status : status
          }
        },
        deleteTaxBtn(idtax){
          console.log('delete tax')
          this.isLoadingStates = true
          this.$swal({
          title: "Delete this Tax?",
          text: "Are you sure?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Yes, Delete it!"
          }).then((result) => {
              if (result.value) {
                  window.billing.put('deletetax/' + idtax,{
                          user_id : window.localuserdata
                    }).then((response) => {
                      console.log('delete ' + response.data)
                          this.isLoadingStates = false   
                          if(!response.data.success){
                            this.$swal.fire({
                              type: 'warning',
                              title: 'Associated taxes',
                              showConfirmButton: false,
                              timer: 2000
                              })
                             
                          }else {
                            this.getTaxes()
                             this.$swal.fire({
                              type: 'success',
                              title: 'Deleted Taxes Successful',
                              showConfirmButton: false,
                              timer: 2000
                              })
                          }
                         
                          }).catch((error) => console.log(error,this.isLoadingStates = false));

              }
          });
          this.isLoadingStates = false;   
        },
        MetDeleteTaxBtn(idtax){
          this.isLoadingStates = true
          this.$swal({
    title: "Delete this Taxe?",
    text: "Are you sure?",
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    confirmButtonText: "Yes, Delete it!"
    }).then((result) => {

        if (result.value) {
            window.billing.post('taxes/',{
                    user_id : window.localuserdata,
                    idtax: idtax
              }).then((response) => {
                    console.log(response.data);
                    this.isLoadingStates = false
                    this.getTaxes()
                    this.$notify({
                    group: 'noti',
                    title: 'Deleted',
                    type: 'success',
                    text: 'Deleted Taxes Successful'
                  });
                    }).catch((error) => console.log(error,this.isLoadingStates = false));

        }
      });
      this.isLoadingStates = false   
     },
    MetAddNewTaxBtn(){
     this.$modal.show('setting-taxe');
      this.FormTax = {
        btnNameTax : 'ADD',
        ActionTaxe : 'AddTaxe',
        state_id : 0,
        status : 1
      }
    },
    checkMove(){
          this.TaxesLists.map((taxes,index)=>{
            taxes.orderitem = index + 1
          })
          window.billing.put('taxes/order/' + window.localuserdata ,{
                user_id : window.localuserdata,
                taxesall : this.TaxesLists
           }).then((response) => {
                 console.log(response.data);
                 this.getTaxes()
                }).catch((error) => console.log(error,this.isLoading = false));
    },
  },
  computed : {
     dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.btnmove{
    position: absolute;
    left: 0px!important;
    top: 0px!important;
    width: 13px;
    height: 100%;
    cursor: pointer;
    background-color: #e1f2fb;
    z-index: 10;
    color: #afafaf;
    font-size: 12px;
    line-height: 75px;
    text-align: center;
    vertical-align: middle;
    font-weight: normal;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover{
        background-color: #e0e0e0;
        cursor: move;
    }
}
</style>


